import React, { useEffect, useState } from 'react';
import { Form, Input, Row, Typography, Spin, Modal, Button, Space } from 'antd';
import { fetchProduct, patchProduct } from 'services/product';
import { FormLabel, message } from 'components/common';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';

const { Text } = Typography;
type EditProductSKUProps = {
  visible: boolean;
  onHide: () => void;
  product?: { id: number; productId: string };
};
export default function EditProductSKUDialog(
  props: EditProductSKUProps
): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState<ProductRow | null>();
  const { visible, onHide } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    const fetch = async () => {
      if (props.product && props.visible) {
        setLoading(true);
        const newProduct = await fetchProduct(props.product.productId);
        setProduct(newProduct);
        if (newProduct) {
          form.setFieldsValue({
            SKU: newProduct.sku,
          });
        }
        setLoading(false);
      }
    };
    fetch();
  }, [props, form]);
  const onSubmit = async () => {
    if (!product) {
      return;
    }
    let values: StringKAnyVPair = {};
    try {
      values = await form.validateFields();
    } catch (e) {
      return;
    }
    setLoading(true);
    await patchProduct(product.productId, values);
    message.success({ content: 'Update product SKU success' });
    setLoading(false);
    onHide();
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  /**
   * Modal Footer
   * @returns {JSX.Element}
   */
  const Footer = (): JSX.Element => {
    return (
      <Row justify="space-between">
        <Button>Edit Alternates</Button>
        <Space>
          <Button key="submit" type="primary" onClick={onSubmit} icon={<EditOutlined />}>
            Edit SKU
          </Button>
          <Button onClick={onHide} icon={<CloseOutlined />}>Cancel</Button>
        </Space>
      </Row>
    );
  };
  return (
    <Modal
      title="Edit Product SKU"
      centered
      visible={visible}
      width={600}
      destroyOnClose
      onCancel={onHide}
      getContainer={false}
      footer={<Footer />}
    >
      <Spin spinning={loading}>
        <Row>
          <Text>{`SKU:'${product && product.sku}'`}</Text>
        </Row>
        <Row justify="center" style={{ marginTop: 20 }}>
          <Form
            /* eslint-disable react/jsx-props-no-spreading */
            {...layout}
            form={form}
          >
            <Form.Item
              name="SKU"
              label={<FormLabel>New SKU</FormLabel>}
              rules={[{ required: true, message: 'Please input SKU!' }]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Row>
      </Spin>
    </Modal>
  );
}
EditProductSKUDialog.defaultProps = {
  product: undefined,
};
